<nimbus-chart-pie
  chartRadiusPercent="75"
  chartCenterXPercent="20"
  donutFactor="0.6"
  [data$]="data$"
  [showAggregatedLabel]="true"
  [legendOption]="{ position: 'Right', xPosition: '45%' }"
></nimbus-chart-pie>
